import {
	getPartnersStatisticsKeyStatistics,
	type PartnerKeyStatisticsFilterDto,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

const PARTNER_KEY_STATISTICS = "PARTNER_KEY_STATISTICS";

export const getPartnersStatisticsKeyStatisticsQueryKey = (
	filter: PartnerKeyStatisticsFilterDto,
) => {
	return [PARTNER_KEY_STATISTICS, filter.regionId, filter.marketId] as const;
};

export function usePartnerKeyStatisticsQuery(
	filter: PartnerKeyStatisticsFilterDto,
) {
	return useQuery({
		queryKey: getPartnersStatisticsKeyStatisticsQueryKey(filter),
		queryFn: processResponse(() =>
			getPartnersStatisticsKeyStatistics(filter.regionId, filter.marketId),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
